// extracted by mini-css-extract-plugin
export var activityContainer = "_lq-0";
export var typingIndicatorContainer = "_lq-1";
export var typingIndicatorDot = "_lq-2";
export var wave = "_lq-3";